export {NgSelectorModule} from './src/ng-selector.module';
export {NgSelectorComponent} from './src/ng-selector.component';
export {NgSelectorValidator} from './src/ng-selector.validator';


// WEBPACK FOOTER //
// ./~/ng-selector/index.ts